import React from 'react'
import { push } from 'react-router-redux'
import { withLocalize } from 'react-localize-redux'

import { store } from '../../helpers'
import { alertActions } from '../../actions'
import { FormErrors } from '../../components/FormErrors'
import { recoverableServices } from '../../services'

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      password: '',
      password_confirmation: '',
      formErrors: { password: '', password_confirmation: '' },
      passwordValid: false,
      passwordConfirmationValid: false,
      formValid: false,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChange(event) {
    const { name, value } = event.target
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value)
      }
    )
  }

  handleSubmit(event) {
    event.preventDefault()
    const { formValid, password, password_confirmation } = this.state
    const { dispatch } = store

    if (formValid) {
      const { token } = this.props.match.params
      const { translate } = this.props

      recoverableServices
        .update({ password, password_confirmation }, token)
        .then(
          response => {
            dispatch(push('/'))
            dispatch(alertActions.success(translate('alert.passwordSent')))
          },
          error => {
            if (error.response) {
              const errors = error.response.data.errors
              if (errors) {
                errors.forEach(e => {
                  dispatch(alertActions.error(e))
                })
              }
            }
          }
        )
    }
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors
    let { passwordValid, passwordConfirmationValid } = this.state
    let { password, password_confirmation } = this.state
    const { translate } = this.props

    switch (fieldName) {
      case 'password':
        if (value !== '') {
          passwordValid = value.length >= 6
          fieldValidationErrors.password = passwordValid
            ? ''
            : translate('resetPassword.form.errors.password.min')
          if (passwordValid) {
            passwordConfirmationValid =
              value === password_confirmation &&
              password_confirmation.length > 0
            fieldValidationErrors.password_confirmation = passwordConfirmationValid
              ? ''
              : translate('resetPassword.form.errors.password.match')
          }
        } else {
          passwordValid = false
          passwordConfirmationValid = false
          fieldValidationErrors.password = ''
          fieldValidationErrors.password_confirmation = ''
        }
        break
      case 'password_confirmation':
        if (value !== '') {
          passwordConfirmationValid = value === password
          fieldValidationErrors.password_confirmation = passwordConfirmationValid
            ? ''
            : translate('resetPassword.form.errors.password.match')
        } else passwordConfirmationValid = false
        if (passwordValid)
          fieldValidationErrors.password_confirmation = passwordConfirmationValid
            ? ''
            : translate('resetPassword.form.errors.password.match')
        else fieldValidationErrors.password_confirmation = ''
        break
      default:
        break
    }

    this.setState(
      {
        passwordValid: passwordValid,
        passwordConfirmationValid: passwordConfirmationValid,
        formErrors: fieldValidationErrors,
      },
      this.validateForm
    )
  }

  validateForm() {
    const { passwordValid, passwordConfirmationValid } = this.state
    this.setState({ formValid: passwordValid && passwordConfirmationValid })
  }

  errorClass(error) {
    return error.length === 0 ? '' : 'has-error'
  }

  render() {
    const { formErrors, formValid } = this.state
    const { translate } = this.props

    return (
      <div className="mt-4 mb-4">
        <div className="row flex-row justify-content-center">
          <div className="col-lg-5">
            <h4>{translate('resetPassword.header')}</h4>
            <div className="mt-2 mb-2">
              <FormErrors formErrors={formErrors} />
            </div>
            <form name="form" onSubmit={this.handleSubmit}>
              <div
                className={`form-group ${this.errorClass(formErrors.password)}`}
              >
                <label>
                  {translate('resetPassword.form.label.newPassword')}
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  onChange={this.handleChange}
                />
              </div>
              <div
                className={`form-group ${this.errorClass(
                  formErrors.password_confirmation
                )}`}
              >
                <label>
                  {translate('resetPassword.form.label.confirmation')}
                </label>
                <input
                  type="password"
                  className="form-control"
                  name="password_confirmation"
                  onChange={this.handleChange}
                />
              </div>
              <button
                type="submit"
                name="submit"
                className="btn btn-primary"
                disabled={!formValid}
              >
                {translate('resetPassword.form.label.submit')}
              </button>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default withLocalize(ResetPassword)
